import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NextQuarterGoal } from 'src/app/leader-toolkit/models/hospital-dashboard.model';

@Component({
  selector: 'vc-hospital-next-quarter-goals',
  templateUrl: './hospital-next-quarter-goals.component.html',
  styleUrl: './hospital-next-quarter-goals.component.scss',
  standalone: false,
})
export class HospitalNextQuarterGoalsComponent {
  @Input() goals: NextQuarterGoal[] = [];
  @Input() note = '';

  @Output() openResource = new EventEmitter<string>();
}